import { createSlice } from "@reduxjs/toolkit";
import { countryList, languageList } from '../../constants/index.js';

// Helper functions to get stored values from session storage
const getStoredCountry = () => {
  const storedCode = sessionStorage.getItem('countryCode');
  const country = countryList.find(c => c.countryCode === storedCode);
  
  if (country) {
    return {
      value: country.countryCode,
      label: `${country.name} (${country.flag})`,
    };
  }
  
  return {
    value: 'US',
    label: 'United States (🇺🇸)',
  };
};

const getStoredLanguage = () => {
  const storedCode = sessionStorage.getItem('languageCode');
  const language = languageList.find(l => l.code === storedCode);
  
  if (language) {
    return {
      value: language.code,
      label: `${language.flag} ${language.name} ${language.language}`,
    };
  }
  
  return {
    value: 'en-US',
    label: 'English (US) (🇺🇸)',
  };
};

const getStoredCurrency = () => {
  const storedCode = sessionStorage.getItem('currencyCode');
  const currency = languageList.find(c => c.currencyCode === storedCode);
  
  if (currency) {
    return {
      value: currency.currencyCode,
      label: `${currency.currencyCode}-${currency.currencyName} (${currency.currency})`,
    };
  }
  
  return {
    value: 'USD',
    label: 'USD-US Dollar ($)',
  };
};

const getStoredNumberSystem = () => {
  const storedCode = sessionStorage.getItem('numberSystem');
  return storedCode || 'Western';
};

// Initialize state from session storage
const initialState = {
  country: getStoredCountry(),
  language: getStoredLanguage(),
  currency: getStoredCurrency(),
  numberSystem: getStoredNumberSystem(),
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setCountry(state, { payload }) {
      state.country = payload;
      // Save to session storage
      sessionStorage.setItem('countryCode', payload.value);
    },
    setLanguage(state, { payload }) {
      state.language = payload;
      // Save to session storage
      sessionStorage.setItem('languageCode', payload.value);
    },
    setCurrency(state, { payload }) {
      state.currency = payload;
      // Save to session storage
      sessionStorage.setItem('currencyCode', payload.value);
    },
    setNumberSystem(state, { payload }) {
      state.numberSystem = payload;
      // Save to session storage
      sessionStorage.setItem('numberSystem', payload);
    },
    resetSettings(state) {
      state.country = {
        value: 'US',
        label: 'United States (🇺🇸)',
      };
      state.language = {
        value: 'en-US',
        label: 'English (US) (🇺🇸)',
      };
      state.currency = {
        value: 'USD',
        label: 'USD-US Dollar ($)',
      };
      state.numberSystem = 'Western';
      // Clear session storage
      sessionStorage.removeItem('countryCode');
      sessionStorage.removeItem('languageCode');
      sessionStorage.removeItem('currencyCode');
      sessionStorage.removeItem('numberSystem');
    },
  },
});

export const { setCountry, setLanguage, setCurrency, setNumberSystem, resetSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
